import {ProgressCircle} from './ProgressCircle';
import React, {ReactNode} from 'react';
import styled from 'styled-components';
import {Property} from 'csstype';

interface ProgressCircleAroundContentProps {
  progressColor?: Property.Color;
  baseColor?: Property.Color;
  progressWidth: number;
  fraction: number;
  contentSize: number;
  children?: ReactNode;
}

/**
 * Create a progress circle around some uniformly-sized content.
 * The content itself must occupy a square with side length `contentSize`.
 *
 * @param props
 * @constructor
 */
// Should extend FunctionComponent<ProgressCircleProps>, but we need to use this in react 15, where that's not a thing.
// TODO combine me with SimpleProgressRing...
export const ProgressCircleAroundContent = (props: ProgressCircleAroundContentProps) => {
  const {children, contentSize, progressWidth} = props;
  const radius = (progressWidth + contentSize) / 2;
  return (
    <ProgressCircle {...props} radius={radius}>
      {children && (
        <ContentDiv
          style={{
            marginLeft: -contentSize - progressWidth / 2,
            marginTop: progressWidth / 2,
          }}
          className="progress-circle-around-content-content">
          {children}
        </ContentDiv>
      )}
    </ProgressCircle>
  );
};

const ContentDiv = styled.div`
  position: relative;
  display: inline-block;
`;
